import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Vector",
      d: "M10.8362 0.819879L12.6176 4.38886C12.8347 4.82136 13.2551 5.12445 13.7375 5.19256L17.7243 5.76469C18.9441 5.93837 19.4334 7.42318 18.5478 8.27456L15.6637 11.0535C15.3122 11.3906 15.1537 11.8776 15.2364 12.3544L15.9187 16.2775C16.1289 17.4797 14.8505 18.3958 13.7582 17.827L10.1918 15.9744C9.75767 15.7497 9.2408 15.7497 8.80664 15.9744L5.24028 17.827C4.14798 18.3958 2.87305 17.4797 3.07979 16.2775L3.76205 12.3544C3.84475 11.8776 3.68624 11.3906 3.33478 11.0535L0.450679 8.27456C-0.431435 7.42318 0.0544169 5.94178 1.27421 5.76469L5.26095 5.19256C5.74681 5.12445 6.16374 4.82136 6.38083 4.38886L8.16228 0.819879C8.70671 -0.273293 10.2849 -0.273293 10.8327 0.819879H10.8362Z",
      fill: "#FFA800"
    }, null, -1)
  ])))
}
export default { render: render }